<template>
    <button :class="className" class="btn" @click="e => !disabled && $emit('click', e)" :disabled="disabled"><slot /></button>
</template>

<script>
export default {
    props: ["disabled", "className"]
};
</script>
<style scoped>
button:disabled {
    background-color: gray;
    color: white;
    cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// rounded-button.vue?a533a052